export enum AlertType {
  Date = 'DATE',
  RecurringInterval = 'RECURRING_INTERVAL',
  Interval = 'INTERVAL',
  Days = 'DAYS',
  Min = 'MIN_VALUE',
  Max = 'MAX_VALUE',
  RoutineCompletions = 'ROUTINE_COMPLETIONS',
  DaysSkipped = 'DAYS_SKIPPED',
}

export enum AlertInputs {
  alertLabel = 'alertLabel',
  alertLabelPlaceholder = 'alertLabelPlaceholder',
  startDate = 'startDate',
  endDate = 'endDate',
  minValue = 'minValue',
  maxValue = 'maxValue',
  days = 'days',
  daysStartDate = 'daysStartDate',
  completions = 'completions',
  daysSkipped = 'daysSkipped',
  onDate = 'onDate',
  intervalRoutineId = 'intervalRoutineId',
  onInterval = 'onInterval',
  onIntervalStart = 'onIntervalStart',
  dayInterval = 'dayInterval',
  dayIntervalUnit = 'dayIntervalUnit',
}

export enum AlertTriggerConfigKeys {
  onInterval = 'onInterval',
  dayIntervalUnit = 'dayIntervalUnit',
  ceiling = 'ceiling',
  floor = 'floor',
  onCompletionCount = 'onCompletionCount',
  daysSinceCompleted = 'daysSinceCompleted',
  every = 'every',
  onDate = 'onDate',
}

export type ClearButtonProps = {
  inputType: AlertInputs;
};

export type DeleteLogicProps = ClearButtonProps;
